<script lang="ts" setup>
import type { ChatAgentBusy } from '@sigma/chat-common/ChatEvent.js';
import { defineChatEventProps } from '@sigma/client/chat/defineChatEventProps.js';
import ChatAgentBusyDisplay from '@sigma/ui/chat/ChatAgentBusy.vue';
import ChatEventWrapper from '@sigma/ui/chat/ChatEventWrapper.vue';

import chatCss from './chat.module.scss';

defineProps(defineChatEventProps<ChatAgentBusy>());
</script>

<template>
  <ChatEventWrapper
    tid="agent-busy"
    :event="event"
    :class="chatCss.container"
  >
    <ChatAgentBusyDisplay />
  </ChatEventWrapper>
</template>
